import { Toaster as HotToaster } from 'react-hot-toast';

export function Toaster() {
  return (
    <HotToaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        // Define default options
        className: 'shadow-xl text-sm font-medium',
        duration: 3000,
        style: {
          overflowWrap: 'anywhere',
        },
      }}
    />
  );
}
